import { BaseRepo, FirestoreUpdate } from "./base/BaseRepo";
import { UserModel } from "@/models/UserModels";
import { auth } from "@/services/firebase";
import { updateProfile } from "firebase/auth";
import { createUserMigrationManager } from "@/utils/migrations";


// src/repos/RoundRepo.ts
/**
 * Repository for models in the users collection
 */
export class UsersRepo extends BaseRepo<UserModel> {
    protected collectionName = 'users';

    constructor() {
        super();
        this.setupMigrations(createUserMigrationManager());
    }

    async update(id: string, updates: FirestoreUpdate<UserModel>): Promise<void> {
        // If displayName is being updated, also update Firebase Auth profile
        if (updates.displayName && auth?.currentUser) {
            await updateProfile(auth!.currentUser, {
                displayName: typeof updates.displayName === 'string' ? updates.displayName : null
            });
        }

        // Call parent update method to handle Firestore and cache updates
        await super.update(id, updates);
    }

    async getByEncodedEmail(encodedEmail: string): Promise<UserModel | null> {
        return await this.getByProperty('encodedEmail', encodedEmail);
    }


}